export { default } from './HeadingDivider'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/HeadingDivider/index.js